import React from 'react';

function RequiredMark(props) {
    return (
        <span className="ml-2 text-danger text-18" style={{lineHeight:"15px"}}>&#8226;</span>
    );
}

export default RequiredMark;